import { render } from "./PixelImage.vue?vue&type=template&id=04ae70c2&scoped=true"
import script from "./PixelImage.vue?vue&type=script&lang=js"
export * from "./PixelImage.vue?vue&type=script&lang=js"

import "./PixelImage.vue?vue&type=style&index=0&id=04ae70c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ae70c2"]])

export default __exports__